import React from "react";
import "./side.css";

export default function Side() {
    return (
        <div className="side">
            <div className="ad"></div>
        </div>
    );
}
